<script lang="ts">
  import DownChevron from '$lib/assets/icons/DownChevron.svelte';
  import { onDestroy } from 'svelte';

  import { slide } from 'svelte/transition';

  export let opacity = '0.8';
  export let fontWeight = 'var(--font-weight-medium)';

  let open = false;
  const handleClick = () => (open = !open);

  onDestroy(() => (open = false));
</script>

<div>
  <button on:click={handleClick}>
    <span class="title" style="--opacity:{opacity}; --font-weight:{fontWeight}">
      <slot name="head" />
    </span>
    <div class="icon-wraper" class:active={open}>
      <DownChevron fill={'#bababa'} />
    </div>
  </button>
  {#if open}
    <div class="body" transition:slide|global>
      <slot name="content" />
    </div>
  {/if}
</div>

<style lang="scss">
  button {
    display: flex;
    justify-content: space-between;
    background: none;
    font-size: var(--font-size-base);
    font-weight: var(--font-weight);
    border: none;
    width: 100%;
    padding: 16px 0px;
  }

  .title {
    color: var(--color-title);
    opacity: var(--opacity);
    text-align: left;
  }

  .body {
    border-radius: 0 0 20px 20px;
    padding-bottom: 8px;
    color: #ffffff9a;
    font-family: Poppins;
    font-size: var(--font-size-sm);
    font-style: normal;
    font-weight: var(--font-weight-normal);
    line-height: 18px; /* 150% */
  }

  .icon-wraper {
    transition: transform 0.5s ease-in-out;
    transform: rotate(-90deg);
  }

  .icon-wraper.active {
    transform: rotate(0deg);
  }
</style>
